export default __webpack_public_path__ + "static/media/bullet-adelheid.bee01679.png";